const API_VERSIONS = {
    ACCOUNT : 'v1',
    MEMBERS: 'v1',
    DEPOSITS: 'v1',
    CHARGE: 'v1',
    REPORTS: 'v1',
    LIBRARY: 'v1',
}

export default API_VERSIONS;